// extracted by mini-css-extract-plugin
module.exports = {"modal":"LoadingModal_modal__1i5J5","Loader":"LoadingModal_Loader__97tK8"};